import { render, staticRenderFns } from "./Templateyh_1.vue?vue&type=template&id=2f5732b1&scoped=true&"
import script from "./Templateyh_1.vue?vue&type=script&lang=js&"
export * from "./Templateyh_1.vue?vue&type=script&lang=js&"
import style0 from "./Templateyh_1.vue?vue&type=style&index=0&id=2f5732b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5732b1",
  null
  
)

export default component.exports